import React from "react";
import Section from "../../components/Home";
import CreateBTN from "../../components/CreateBTN";
import CheckList_Icon from "../../imgs/Icons/checklist_icon.svg";
import SobreUA from "../../components/Home/TestemunhoVid";
// import { Agenda } from "@uaveiro/ui";
// import agenda from "../../json/Agenda";
import { withNamespaces } from 'react-i18next';

// eslint-disable-next-line import/no-anonymous-default-export
const Homepage_index = ({t}) => {
  return (
      <>
        <div id="start" className="fantasmaAncora"></div>
        <div id="main">
          <Section />
          {/* <Agenda
            title={agenda.title}
            backgroundColor={agenda.backgroundColor}
            eventStyles={{
              date: { textColor: "#fff" },
              descriptionColor: "#fff",
              titleColor: "#fff"
            }}
            data={agenda.data}
          /> */}
          <SobreUA/>
          <CreateBTN
            link="/todolist#start"
            icon={CheckList_Icon}
            iconAlt={t('moduleBotoes:B3.Alt')}
            btnName={t('moduleBotoes:B3.B')}
          />
        </div>
      </>
  );
};

export default withNamespaces() (Homepage_index);